/**
 * Activity-type inference based on distance + duration.
 *
 * Standard sport-science thresholds:
 *   • Walking  →  speed < 7.0 km/h  (pace > 8'34" / km)
 *   • Running  →  speed ≥ 7.0 km/h
 *
 * 7 km/h is the empirical "transition speed" where most adults switch
 * from a walking gait to a running gait (Margaria 1976; Saibene 2003).
 *
 * Edge cases:
 *   • Sessions shorter than 60s are too noisy to classify → walk.
 *   • Distance ≤ 0 (e.g. paused-only sessions) → walk.
 */
export const RUN_SPEED_THRESHOLD_KMH = 7.0;

export function getAvgSpeedKmh(distanceKm, durationSeconds) {
  if (!distanceKm || !durationSeconds || durationSeconds < 1) return 0;
  return (distanceKm / durationSeconds) * 3600;
}

export function inferActivityType(distanceKm, durationSeconds) {
  if (!distanceKm || distanceKm <= 0) return 'walk';
  if (!durationSeconds || durationSeconds < 60) return 'walk';
  const speed = getAvgSpeedKmh(distanceKm, durationSeconds);
  return speed >= RUN_SPEED_THRESHOLD_KMH ? 'run' : 'walk';
}

/**
 * Localised label for the inferred activity type.
 * Falls back to Italian if a translation key is missing.
 */
export function getActivityLabel(distanceKm, durationSeconds, t) {
  const type = inferActivityType(distanceKm, durationSeconds);
  if (type === 'run') {
    return t('dashboard.runTitle', 'Corsa');
  }
  return t('dashboard.walkTitle', 'Camminata');
}
